import React, { useEffect, useRef } from 'react'
import { useEventRegRefreshContext } from '../reducers/event-reg-refresh-reducers'
import { IEpiProps } from '../models/event-reg-refresh-models'

interface MonthYearFilterProps {
  selectedDates: string[]
  onDateSelectionChange: (monthValue: string, isChecked: boolean) => void
  isOpen: boolean
  onToggle: () => void
}

interface IContextProps {
  epiProps: IEpiProps
}

export const MonthYearFilter: React.FC<MonthYearFilterProps> = ({
  selectedDates,
  onDateSelectionChange,
  isOpen,
  onToggle
}) => {
  const { epiProps }: IContextProps = useEventRegRefreshContext()!
  const filterRef = useRef<HTMLDivElement>(null)

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (filterRef.current && !filterRef.current.contains(event.target as Node) && isOpen) {
        onToggle()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [isOpen, onToggle])

  // Generate list of current month plus next 5 months or # of months passed as parameter
  const generateMonthList = (numberOfMonths: number = 6) => {
    const months = [];
    const currentDate = new Date();

    for (let i = 0; i < numberOfMonths; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
      const monthName = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      const monthValue = `${date.getMonth() + 1}/${date.getFullYear()}`; // MM/YYYY format
      months.push({ display: monthName, value: monthValue });
    }

    return months;
  };

  const getAccordionHeading = () => {
    if (isOpen || selectedDates.length === 0) {
      return epiProps.monthYearFilterHeader
    }

    // Convert selected date values back to display format
    const monthList = generateMonthList(12);
    const selectedDisplayNames = selectedDates
      .map(dateValue => {
        const month = monthList.find(m => m.value === dateValue);
        return month ? month.display : dateValue;
      })
      .join(', ');

    return selectedDisplayNames;
  };

  return (
    <div className="app-dropdown-container filters-date" ref={filterRef}>
      <button className={`app-dropdown-toggle`} aria-expanded={isOpen} onClick={onToggle}>
        <span className="app-dropdown-toggle-text">{getAccordionHeading()}</span>
        <svg className="svg-icon" aria-hidden="true" focusable="false">
          <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-chevron-down" />
        </svg>
      </button>

      {isOpen && (
        <div className="app-dropdown-panel">
          {generateMonthList(12).map((month) => (
            <label className="filters-checkbox-item custom-checkbox" key={month.value}>
              {month.display}
              <input
                type="checkbox"
                value={month.value}
                checked={selectedDates.includes(month.value)}
                onChange={(e) => onDateSelectionChange(month.value, e.target.checked)}
              />
            </label>
          ))}

        </div>
      )}
    </div>
  )
}